// src/views/unidades/GerarUnidadesModal.jsx
import React, { useState } from "react";
import unidadesService from "../../services/unidadesService";
import ConfirmModal from "../../components/ui/ConfirmModal";

export default function GerarUnidadesModal({ show, onClose, onGerado, idCondominio, condominioNome="" }) {
  const [config, setConfig] = useState({ blocos:"", numInicial:"101", numFinal:"110", diaVencimentoDif:"", areM2:"", fracaoIdeal:"" });
  const [preview, setPreview]     = useState([]);
  const [previewed, setPreviewed] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [gerando, setGerando]     = useState(false);
  const [erro, setErro]           = useState(null);
  const [aviso, setAviso]         = useState(null);
  const [confirmacao, setConfirmacao] = useState(null);
  const askConfirm = (opts) => new Promise(resolve => setConfirmacao({ ...opts, resolve }));

  const setC = (f,v) => { setConfig(p=>({...p,[f]:v})); setPreviewed(false); setPreview([]); };
  const parseBlocos = () => { const b=config.blocos.trim(); if(!b) return [""]; return b.split(",").map(x=>x.trim()).filter(Boolean); };

  const handlePreview = async () => {
    setErro(null);
    if (!idCondominio) { setErro("Selecione um condomínio."); return; }
    if (!config.numInicial||!config.numFinal) { setErro("Informe a numeração inicial e final."); return; }
    setLoading(true);
    try {
      const res = await unidadesService.previewLote({ idCondominio, blocos:parseBlocos(), numInicial:config.numInicial, numFinal:config.numFinal, diaVencimentoDif:config.diaVencimentoDif||null, areM2:config.areM2||null, fracaoIdeal:config.fracaoIdeal||null });
      setPreview(res.data); setPreviewed(true);
    } catch(e){ setErro(e?.message || "Erro ao gerar pré-visualização."); }
    setLoading(false);
  };

  const handleGerar = async () => {
    setErro(null); setAviso(null);
    const novas = preview.filter(u=>!u.jaExiste).length;
    if (novas===0) { setAviso("Todas as unidades já existem. Nada a gerar."); return; }
    const ok = await askConfirm({ titulo:"Confirmar geração?", mensagem:`Serão criadas ${novas} unidade(s). Deseja continuar?`, textoOk:"Gerar", perigo:false });
    if(!ok) return;
    setGerando(true);
    try {
      const res = await unidadesService.gerarLote({ idCondominio, blocos:parseBlocos(), numInicial:config.numInicial, numFinal:config.numFinal, diaVencimentoDif:config.diaVencimentoDif||null, areM2:config.areM2||null, fracaoIdeal:config.fracaoIdeal||null });
      setAviso(res.message); onGerado&&onGerado();
      setTimeout(() => onClose(), 1200);
    } catch(e){ setErro(e?.message || "Erro ao gerar unidades."); }
    setGerando(false);
  };

  if (!show) return null;
  const novas=preview.filter(u=>!u.jaExiste).length;
  const existentes=preview.filter(u=>u.jaExiste).length;

  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}><i className="bi bi-grid-3x3" style={{fontSize:18,color:"#fff"}}/></div>
              <div><h5 className="modal-title mb-0">Gerar Unidades em Lote</h5><small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{condominioNome}</small></div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>
          <div className="modal-body">
            {erro && (
              <div className="alert alert-danger py-2 mb-3" style={{fontSize:13}}>
                <i className="bi bi-exclamation-triangle-fill me-2"/>{erro}
              </div>
            )}
            {aviso && (
              <div className="alert alert-success py-2 mb-3" style={{fontSize:13}}>
                <i className="bi bi-check-circle-fill me-2"/>{aviso}
              </div>
            )}
            <div className="row g-4">
              <div className="col-md-4">
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-sliders"/> Configuração</div>
                  <div style={{background:"var(--bg-highlight)",borderLeft:"3px solid var(--primary-light)",borderRadius:6,padding:"10px 14px",fontSize:12.5,color:"var(--primary)",marginBottom:16}}>
                    <i className="bi bi-info-circle me-2"/>As unidades serão criadas em branco. Você aloca os condôminos depois.
                  </div>
                  <div className="mb-3"><label className="form-label">Blocos <small style={{color:"var(--gray-400)",fontWeight:400}}>(separados por vírgula)</small></label>
                    <input className="form-control" value={config.blocos} onChange={e=>setC("blocos",e.target.value)} placeholder="Ex: A, B, C  (vazio = sem bloco)"/>
                  </div>
                  <div className="row g-2 mb-3">
                    <div className="col-6"><label className="form-label">Nº Inicial <span className="required-mark">*</span></label><input className="form-control" type="number" min="1" value={config.numInicial} onChange={e=>setC("numInicial",e.target.value)}/></div>
                    <div className="col-6"><label className="form-label">Nº Final <span className="required-mark">*</span></label><input className="form-control" type="number" min="1" value={config.numFinal} onChange={e=>setC("numFinal",e.target.value)}/></div>
                  </div>
                  <div className="mb-3"><label className="form-label">Dia Vencimento Padrão</label><input className="form-control" type="number" min="1" max="28" placeholder="Dia (opcional)" value={config.diaVencimentoDif} onChange={e=>setC("diaVencimentoDif",e.target.value)}/></div>
                  <div className="row g-2 mb-4">
                    <div className="col-6"><label className="form-label">Área m²</label><input className="form-control" type="number" step="0.01" placeholder="Opcional" value={config.areM2} onChange={e=>setC("areM2",e.target.value)}/></div>
                    <div className="col-6"><label className="form-label">Fração Ideal</label><input className="form-control" type="number" step="0.000001" placeholder="Opcional" value={config.fracaoIdeal} onChange={e=>setC("fracaoIdeal",e.target.value)}/></div>
                  </div>
                  <button className="btn btn-primary w-100" onClick={handlePreview} disabled={loading}>{loading?<><span className="spinner-border spinner-border-sm me-2"/>Calculando...</>:<><i className="bi bi-eye"/> Pré-visualizar</>}</button>
                </div>
              </div>
              <div className="col-md-8">
                <div className="form-section">
                  <div className="form-section-title d-flex justify-content-between align-items-center">
                    <span><i className="bi bi-table"/> Pré-visualização</span>
                    {previewed&&<div className="d-flex gap-2">
                      <span style={{background:"var(--bg-success-soft)",color:"#166534",padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:600}}>{novas} novas</span>
                      {existentes>0&&<span style={{background:"var(--bg-warning-soft)",color:"#854D0E",padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:600}}>{existentes} já existem</span>}
                    </div>}
                  </div>
                  {!previewed?(
                    <div style={{textAlign:"center",padding:"60px 0",color:"var(--gray-400)"}}><i className="bi bi-grid-3x3" style={{fontSize:40,display:"block",marginBottom:10}}/><p style={{fontSize:14}}>Configure e clique em <strong>Pré-visualizar</strong></p></div>
                  ):(
                    <div style={{maxHeight:340,overflowY:"auto"}}>
                      <table className="table table-custom">
                        <thead><tr><th>#</th><th>Unidade</th><th>Bloco</th><th>Área m²</th><th>Fração Ideal</th><th>Vencimento</th><th>Situação</th></tr></thead>
                        <tbody>{preview.map((u,i)=>(
                          <tr key={i} style={{opacity:u.jaExiste?.6:1}}>
                            <td style={{color:"var(--gray-400)",fontSize:12}}>{i+1}</td>
                            <td style={{fontWeight:700,color:"var(--primary)"}}>{u.unidade}</td>
                            <td>{u.bloco||<span style={{color:"var(--gray-300)"}}>—</span>}</td>
                            <td>{u.areM2||<span style={{color:"var(--gray-300)"}}>—</span>}</td>
                            <td style={{fontSize:12}}>{u.fracaoIdeal||<span style={{color:"var(--gray-300)"}}>—</span>}</td>
                            <td>{u.diaVencimentoDif?`Dia ${u.diaVencimentoDif}`:<span style={{color:"var(--gray-300)"}}>—</span>}</td>
                            <td>{u.jaExiste?<span style={{background:"var(--bg-warning-soft)",color:"#854D0E",padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}}>Já existe</span>:<span style={{background:"var(--bg-success-soft)",color:"#166534",padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}}>✓ Nova</span>}</td>
                          </tr>
                        ))}</tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer d-flex justify-content-between">
            <div style={{fontSize:12,color:"var(--gray-400)"}}>{previewed&&<span><strong style={{color:"var(--primary)"}}>{novas}</strong> unidade(s) serão criadas</span>}</div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-success" onClick={handleGerar} disabled={!previewed||gerando||novas===0}>{gerando?<><span className="spinner-border spinner-border-sm me-2"/>Gerando...</>:<><i className="bi bi-lightning-charge"/> Confirmar e Gerar</>}</button>
            </div>
          </div>
        </div>
      </div>

      {confirmacao && (
        <ConfirmModal
          titulo={confirmacao.titulo}
          mensagem={confirmacao.mensagem}
          textoOk={confirmacao.textoOk}
          perigo={confirmacao.perigo}
          onConfirm={() => { confirmacao.resolve(true); setConfirmacao(null); }}
          onCancel={() => { confirmacao.resolve(false); setConfirmacao(null); }}
        />
      )}
    </div>
  );
}
